import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const categoryIds = [
    "4121e7b2-af4c-432b-97de-9bec8b97e31a", // prod
    "7f8f2a7b-0473-49b9-9a21-abda414d5c1d" // acc
];

export const ExterieurFilter = ({ condensed }) => {
    const filter = useFilter("opties").find((category) =>
        categoryIds.includes(category.optiecategorieId)
    );
    const count = useCount("zoekopties");
    const [value, , onChange] = useField("zoekoptieIds");

    const options =
        filter?.zoekopties?.map(({ zoekoptieId, naam }) => ({
            id: zoekoptieId,
            displayName: naam,
            aantal: count[zoekoptieId]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-exterieur"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 3}
                datalayerKey="zoekoptieId"
                maxSize={condensed ? 5 : 0}
            />
        </Grid>
    );
};
